// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-progress-bar{height:1.042vw}.el-progress-bar .el-progress-bar__outer{width:17.292vw!important;height:1.042vw!important;border-radius:0!important;overflow:hidden;position:relative;vertical-align:middle;background:rgba(40,133,152,.5)}.el-progress-bar .el-progress-bar__outer .el-progress-bar__inner{border-radius:0!important}.el-progress__text{display:none!important}", ""]);
// Exports
module.exports = exports;
